/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Error":"Error_0PrPS","button":"button_NZ081","title":"title_DzPSC","text":"text_iCXI4"};